<template>
    <div>
        <MainMenuResponsive :menu="menu" />
        <!--end-small-nav-->
        <div class="container-fluid p-0 m-0">
            <div class="background__index">
                <div class="background__index-fruit">
                    <img src="front/assets/images/1.png" alt="">
                    <img src="front/assets/images/2.png" alt="">
                </div>
                <!--navBar-->
                <main-menu :menu="menu" />
                <!--end-navBar-->
                <div class="container">
                    <slot />
                </div>
            </div>
        </div>

    </div>
</template>

<script>


import MainMenuResponsive from "./../Menus/MainMenuResponsive";
import MainMenu from "./../Menus/MainMenu";
export default {

    components : {MainMenuResponsive , MainMenu},
    props: {
        menu: Object,
    },
}
</script>

<style scoped>

</style>
